import React, { memo } from 'react';
import PropTypes from 'prop-types';

const FirstAndLastName = ( { row } ) => {
	return <span>{ row.firstName } { row.lastName }</span>;
};

FirstAndLastName.propTypes = { row: PropTypes.object.isRequired };

export default memo( FirstAndLastName );
